<app-dialog-banner text="{{ title }} {{ sr?.refNr }}" [dialogRef]="dialogRef"></app-dialog-banner>
<mat-dialog-content class="mat-typography" style="max-width: 900px;"
        [attr.data-form-ready]="ready ? 'true' : null">
    <app-field-set [fieldSet]="fieldSet" [isPhone]="isPhone" [initComplete]="ready"></app-field-set>

    <p class="wo-comment">{{comment}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    @if (!fieldSet.formGroup?.valid) {
        <button mat-raised-button i18n (click)="highlightErrors()">Show Errors</button>
    }
    <button mat-raised-button mat-dialog-close i18n>Cancel</button>
    <button mat-raised-button (click)="closeRequest()" [disabled]="!fieldSet.formGroup?.valid" color="primary"
        data-save-button cdkFocusInitial>{{ saveText }}</button>
</mat-dialog-actions>
